import { Th, Td } from "@chakra-ui/react";
import { getActiveDimensionKeys } from "../Categories/components/Category/helpers";

// Shared read-only dimension rendering for the Scope 2 v2 tables. The mock
// hardcoded Division/Location columns — here we derive the active dimensions
// from the org structure (one column per configured dimension) and resolve
// each saved item id to its display name.

const TH_PROPS = {
  py: 3,
  px: 4,
  fontSize: "13px",
  color: "gray.600",
  fontWeight: "600",
  textTransform: "none",
  letterSpacing: "normal",
};

/**
 * Resolve a saved dimension item id to its display name. Ids may arrive as
 * numbers or strings, so compare stringified. Falls back to "" when unmatched.
 */
export const getDimensionItemName = (organizationStructure, dimKey, value) => {
  if (value === null || value === undefined || value === "") return "";
  return (
    organizationStructure?.dimensions?.[dimKey]?.items?.find(
      (it) => `${it.id}` === `${value}`
    )?.name ?? ""
  );
};

/**
 * One <Th> per active dimension, labelled with the dimension's configured name.
 */
export const renderDimensionHeaderCells = (organizationStructure) =>
  getActiveDimensionKeys(organizationStructure).map((dimKey) => (
    <Th key={`dim-head-${dimKey}`} {...TH_PROPS}>
      {organizationStructure.dimensions[dimKey].name}
    </Th>
  ));

/**
 * One read-only <Td> per active dimension for a saved row. `row` carries flat
 * `dimensionOneItem..Five` fields (already flattened from the API record).
 */
export const renderDimensionValueCells = (organizationStructure, row) =>
  getActiveDimensionKeys(organizationStructure).map((dimKey) => (
    <Td key={`dim-val-${dimKey}`} py={3} px={4} fontSize="14px" color="gray.700">
      {getDimensionItemName(organizationStructure, dimKey, row[`${dimKey}Item`])}
    </Td>
  ));

/**
 * Count of active dimension columns — used for table colSpans (totals row,
 * empty-state row) so the lime totals band lines up with the data columns.
 */
export const activeDimensionCount = (organizationStructure) =>
  getActiveDimensionKeys(organizationStructure).length;
